import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';
import authService from "../../domain/services/AuthService";
import { authByEmailStateSelector } from "./selectors";
import { SignInEmailErrorCodeEnum } from "../../domain/enums/SignInEmailErrorEnum";
import { ResetPasswordErrorCodeEnum } from "../../domain/enums/ResetPasswordErrorEnum";
import { setProcessingLoaderVisibility } from "../../../layout/store/actions";
import { AuthProviderEnum } from '../../domain/enums/AuthProvidersEnum';
import { history } from 'src/store';
import { setEmail as setRegistrationEmail } from '../register-by-email/actions';

const namespace = 'AUTH_BY_EMAIL';

export const setEmail = createAction(`${namespace}/SET_EMAIL`);
export const setPassword = createAction(`${namespace}/SET_PASSWORD`);
export const setFormErrors = createAction(`${namespace}/SET_FORM_ERRORS`);

export const setEmailSignInMethod = createAction(`${namespace}/SET_EMAIL_SIGN_IN_METHDO`);

export const emailSignInRequest = createAction(`${namespace}/EMAIL_SIGN_IN_REQUEST`);
export const emailSignInSuccess = createAction(`${namespace}/EMAIL_SIGN_IN_SUCCESS`);
export const emailSignInFailed = createAction(`${namespace}/EMAIL_SIGN_IN_FAILED`);

export const passwordResetRequest = createAction(`${namespace}/PASSWORD_RESET_REQUEST`);
export const passwordResetSuccess = createAction(`${namespace}/PASSWORD_RESET_SUCCESS`);
export const passwordResetFailed = createAction(`${namespace}/PASSWORD_RESET_FAILED`);

export const donePasswordReset = createAction(`${namespace}/RESET_PASSWORD_RESET`)

export function checkEmailUsage() {
  return (dispatch, getState) => {
    dispatch(setProcessingLoaderVisibility(true));

    const { email } = authByEmailStateSelector(getState());

    authService.fetchSignInMethodsForEmail(email)
      .then((response) => {
          if (response.includes(AuthProviderEnum.email)) {
            dispatch(setEmailSignInMethod(true));
          } else if (response.includes(AuthProviderEnum.facebook) || response.includes(AuthProviderEnum.google)) {
            dispatch(
              setFormErrors({
                form: SignInEmailErrorCodeEnum.EmailAlreadyInUse,
              })
            );
          } else {
            dispatch(setRegistrationEmail(email));
            history.push('/register');
          }
        })
      .catch((error) => {
        let formErrors = {};
        switch (error.code) {
          case SignInEmailErrorCodeEnum.InvalidEmail:
            formErrors['email'] = error.code;
            break;
          case SignInEmailErrorCodeEnum.EmailAlreadyInUse:
            formErrors['email'] = error.code;
            break;
        }
        dispatch(batchActions([
          setFormErrors(formErrors),
          emailSignInFailed(error)
        ]));
      })
      .finally(() => {
        dispatch(setProcessingLoaderVisibility(false));
      });
  };
}

export function loginByEmail() {
  return (dispatch, getState) => {

    dispatch(batchActions([
      emailSignInRequest(),
      setProcessingLoaderVisibility(true)
    ]));

    const { email, password } = authByEmailStateSelector(getState());

    authService.signInWithEmail({ email, password })
      .then((response) => {
        dispatch(emailSignInSuccess(response));
      })
      .catch((error) => {
        let formErrors = {};
        switch (error.code) {
          case SignInEmailErrorCodeEnum.InvalidEmail:
            formErrors['email'] = error.code;
            break;
          case SignInEmailErrorCodeEnum.WrongPassword:
            formErrors['password'] = error.code;
            break;
          case SignInEmailErrorCodeEnum.UserDisabled:
          case SignInEmailErrorCodeEnum.UserNotFound:
            formErrors['form'] = error.code;
            break;
        }

        dispatch(batchActions([
          setFormErrors(formErrors),
          emailSignInFailed(error),
          setProcessingLoaderVisibility(false)
        ]));
      });
  };
}

export function resetPassword() {
  return (dispatch, getState) => {
    dispatch(batchActions([
      setProcessingLoaderVisibility(true),
      passwordResetRequest()
    ]));
    const { email } = authByEmailStateSelector(getState());

    authService.sendPasswordResetEmail(email, { url: window.location.origin + '/login/email' })
      .then(() => {
        dispatch(passwordResetSuccess())
      })
      .catch((error) => {
        let formErrors = {};
        switch(error.code) {
          case ResetPasswordErrorCodeEnum.InvalidEmail:
            formErrors['email'] = error.code;
            break;
          case ResetPasswordErrorCodeEnum.UserNotFound:
            formErrors['form'] = error.code;
            break;
        }
        dispatch(batchActions([
          setFormErrors(formErrors),
          passwordResetFailed(error)
        ]));
      })
      .finally(() => {
        dispatch(setProcessingLoaderVisibility(false));
      });
  };
}